import { ProfileOverview } from 'features/profileOverview/ProfileOverview';

export const ProfileOverviewPage = (): JSX.Element => <ProfileOverview />;
